import React, { useState } from "react";
import axios from "axios";
import { BASEURL } from "../Api/Api";
const ZipUpload = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage("❗ Please select a ZIP file.");
      return;
    }

    const formData = new FormData();
    formData.append("zipFile", file);

    try {
      const res = await axios.post(`${BASEURL}/upload-images`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setMessage(res.data.message || "✅ Upload successful!");
    } catch (err) {
      console.error(err);
      setMessage("❌ Upload failed. Check server log.");
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      <h2>📦 Upload Image ZIP</h2>
      <input type="file" accept=".zip" onChange={handleChange} />
      <button onClick={handleUpload} style={{ marginTop: "1rem" }}>
        Upload ZIP
      </button>
      {message && (
        <p style={{ marginTop: "1rem", color: "green" }}>{message}</p>
      )}
    </div>
  );
};

export default ZipUpload;
